module.exports = __webpack_public_path__ + "static/media/player5.3ea502ad.png";